module.exports = __webpack_public_path__ + "img/normal.9c584d24.png";